import IUser from "../types/user-type";
import api from "./auth-interceptor";

class UserService {
  getPublicContent() {
    return api.get("all");
  }

  getUserBoard() {
    return api.get("user");
  }

  getModeratorBoard(userId: string) {
    return api.get("mod", {
      params: { userId },
    });
  }

  getAdminBoard(userId: string) {
    return api.get("admin", {
      params: { userId },
    });
  }

  updateProfile(userId: string, profileContent: IUser) {
    return api.put(`users/${userId}`, profileContent);
  }

  getUserInfoById(userId: string) {
    return api.get(`users/${userId}`);
  }

  searchUsers(query: string): Promise<{ data: IUser[] }> {
    return api.get(`users/search`, {
      params: { query },
    });
  }

  deleteUsers(userId: string) {
    return api.delete(`users/${userId}`);
  }
}


const userService = new UserService();
export default userService;
